export default "__VITE_ASSET__$I9xOnfu__"